import { createSlice } from "@reduxjs/toolkit";
import { deleteStaffRecord } from "../../api/staff";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const deleteStaffSlice = createSlice({
  name: "deleteStaff",
  initialState: data,
  reducers: {
   deleteStaffSlice(state) {
      state.isLoading = true;
    },
   deleteStaffSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteStaffSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteStaffSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const deleteStaffHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(deleteStaffAction.deleteStaffSlice());
    const response: any = await deleteStaffRecord(id);
    
    dispatch(deleteStaffAction.deleteStaffSliceSuccess(response));
  } catch (e: any) {
    dispatch(deleteStaffAction.deleteStaffSliceFailure(e?.response?.data));
  }
};

export default deleteStaffSlice.reducer;
export const deleteStaffAction = deleteStaffSlice.actions;
